<template>
<div>
    <div class="input-group">
        <input
            class="form-control"
            type="text"
            :placeholder="label"
            :title="label"
            v-bind:value="value"
            v-on:input="$emit('input', $event.target.value)" />
        <span class="input-group-append">
            <span class="input-group-text">
                <span class="fa fa-calendar"></span>
            </span>
        </span>
    </div>
</div>
</template>

<script>
export default {
    props: [
        'label',
        'value',
    ],
    data() {
        return {
            
        }
    },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfDatepickerOld.vue